const DpoCorePdfZadost = {
    init: function () {
        const tlacitko = $("#tlacitkoGenerovatZadost");
        if (!tlacitko.length) {
            return;
        }

        tlacitko
            .off("click")
            .on("click", function (e) {
                e.preventDefault();
                if (tlacitko.hasClass("disabled")) {
                    return;
                }
                tlacitko.attr("disabled", true).prop("disabled", true);

                let text = '<p class="text text-center font-weight-bold">';
                text += "Opravdu si přejete si opětovně vygenerovat žádost s aktualizovanými údaji?";
                text += "</p>";
                text += '<div class="text-center">';
                text += '<i class="fa fa-exclamation-triangle fa-fw fa-5x mt-3 mb-4 text-danger"></i>';
                text += "</div>";
                text += "<p class='text text-center'>";
                text += "Dokument bude uložen mezi přílohy žádosti a bude automaticky nabídnut ke stažení.";
                text += "</p>";

                Lemo_Modal.setTitle('Generování pdf žádosti');
                Lemo_Modal.setContent(text);
                Lemo_Modal.addButton('generate', '<i class="fas fa-fw fa-file-pdf"></i> Generovat', 'btn btn-primary', function() {
                    Lemo_Modal.close();
                    DpoCorePdfZadost.generovat();
                });
                Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function() {
                    tlacitko.attr("disabled", false).prop("disabled", false);
                    Lemo_Modal.close();
                });
                Lemo_Modal.build(null);
            });
    },

    generovat: function() {
        const tlacitko = $("#tlacitkoGenerovatZadost");
        if (!tlacitko.length) {
            return;
        }

        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/core/generujPdfZadost";

        const sekceId = $('#idSection').val();
        if (!sekceId) {
            return;
        }
        url += '/' + sekceId;

        const zadostId = $('#idItem').val();
        if (!zadostId) {
            return;
        }
        url += '/' + zadostId;

        const _ch = $("#_ch");
        if (!_ch.length) {
            return;
        }

        $.ajax({
            type: "post",
            url: url,
            data: {"_ch": _ch.val()},
            dataType: "json",
            global: true,
            beforeSend: function() {
                Lemo_Alert.addInfo("Generuji dokument žádosti ...", "generovaniPdfZadostiBeforeSend");
            },
            complete: function() {
                Lemo_Alert.closeById("generovaniPdfZadostiBeforeSend");
                tlacitko.attr("disabled", false).prop("disabled", false);
                DynaCore_Item.miniformReload(103, 4);
            },
            success: function(r) {
                Lemo_Modal.close();
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }

                if (r.hasOwnProperty("status") && true === r["status"]) {
                    if (r.hasOwnProperty("data")) {
                        const data = r["data"];
                        if (data.hasOwnProperty("soubor")) {
                            url = window.location.protocol + "//" + window.location.host;
                            url += "/dpo/core/pdf-zadost/" + zadostId;
                            url += '/' + data["soubor"];
                            setTimeout(function () {
                                Lemo_Alert.closeAll();
                                window.location = url;
                            }, 1500);
                        }
                    }
                }
            },
            error: function() {
                Lemo_Alert.addDanger("Generování dokumentu žádosti selhalo...", "generovaniPdfZadostiError");
            }
        });
    }
}

$(document).ready(function() {
    DpoCorePdfZadost.init();
});
